<template>
    <div class="layout" :style="{ height: minHeight }">
        <Header
            v-if="$route.meta.isHeader"
            :isBack="!!$route.query.mode"
            backName="返回首页"
            :jump="`${currScreenType.contents}/${currScreenType.key}`"
            :title="title"
        />
        <Tags
            v-if="$route.meta.isHeader && $route.meta.isTags"
            :active="$route.meta.active"
            @handleTitle="handleTitle"
        />
        <router-view class="body"></router-view>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Tags from './components/Tags'

export default {
    components: {
        Header,
        Tags
    },
    data() {
        return {
            currScreenType: {},
            title: '',
            minHeight: '',
            timerDate: null,
            time: ['', '', '']
        }
    },
    methods: {
        handleTitle(title) {
            this.title = title
        }
    },
    beforeMount() {
        const clientWidth = document.documentElement.clientWidth
        this.minHeight = `${(1080 / 1920) * clientWidth}px`

        this.currScreenType = JSON.parse(
            sessionStorage.getItem('currScreenType')
        )
        this.title = `${this.currScreenType.label}农业设备装备一张图`
    },
    mounted() {
        document.title = this.title
    }
}
</script>
<style lang="scss" scoped>
.layout {
    display: flex;
    flex-direction: column;
    background-size: 1920px 1080px;
    background-repeat: no-repeat;
    background-position: center top;
    background-image: url('../../assets/images/large-screen-bg.jpg');
    background-color: #04090f; // for ie10
    position: relative;
    > .body {
        padding: 21px 15px 11px 15px;
        display: flex;
        justify-content: space-between;
        flex-grow: 1;
        box-sizing: border-box;
    }
}
</style>
